import { Fragment, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonEventRegistrationCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { EventRegistrationForm } from 'system/components/event-registration/form';
import FormEventRegistration from 'system/components/event-registration/form';
import { EventRegistrationForDE } from 'shell/models/event-registration';
import {
  transformEventRegistration,
  transformEventRegistrationResponse,
} from '../utils/transformer-event-registration';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { AxiosPromise } from 'axios';
import { toast } from 'react-toastify';

const EventRegistrationEditPage = (): React.ReactElement => {
  const paramsData = useParams();

  const navigate = useNavigate();

  const updateEventRegistration = useHttpClient(`${__OPERATION__EVENT__ADMIN__}/iscrizioneEvento`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
      data: {},
    },
  });

  const [eventRegistration] = useHttpFetch<
    HttpResponse<EventRegistrationForDE>,
    transformEventRegistrationResponse
  >(
    `${__OPERATION__EVENT__ADMIN__}/iscrizioneEvento?codiceSottoscrittore=${Number.parseInt(
      paramsData.codiceSottoscrittore
    )}&codiceTipoDestinazione=${Number.parseInt(
      paramsData.codiceTipoDestinazione
    )}&codiceTipoEvento=${paramsData.codiceTipoEvento}&progressivo=${paramsData.progressivo}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformEventRegistration,
    }
  );

  const onSubmit = useCallback((formValues: EventRegistrationForm) => {
    (
      updateEventRegistration({
        data: {
          codiceSottoscrittore: formValues?.subscriberCode
            ? Number.parseInt(formValues?.subscriberCode)
            : undefined,
          codiceTipoEvento: formValues?.eventCode || undefined,
          codiceTipoDestinazione: formValues?.destinationCode
            ? Number.parseInt(formValues?.destinationCode)
            : undefined,
          httpMethod: formValues?.httpMethod || undefined,
          pathSpecificoConsumer: formValues?.pathConsumer || undefined,
          progressivo: paramsData?.progressivo
            ? Number.parseInt(paramsData?.progressivo)
            : undefined,
          microservizioConsumer: formValues?.microConsumer || undefined,
        },
      }) as AxiosPromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/eventmanager/iscrizione-evento');
    });
  }, []);
  return (
    <Fragment>
      <Breadcrumbs
        items={[...CommonEventRegistrationCrumbs, { name: 'Modifica Iscrizione Evento' }]}
      />
      <FormEventRegistration
        title="Modifica Iscrizione Evento"
        onOk={onSubmit}
        initialValues={eventRegistration.data as transformEventRegistrationResponse}
        isEdit
        onCancel={() => {
          navigate('/sistema/eventmanager/iscrizione-evento');
        }}
      />
    </Fragment>
  );
};

EventRegistrationEditPage.displayName = 'Event Registration edit page component';

export default EventRegistrationEditPage;
